// src/utils/useNow.js
// The current time, refreshed every half minute while `active`, so "5 min ago" stays right.
import { useEffect, useState } from 'react';

export function useNow(active = true, everyMs = 30000) {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        if (!active) return undefined;
        setNow(new Date());
        const timer = setInterval(() => setNow(new Date()), everyMs);
        return () => clearInterval(timer);
    }, [active, everyMs]);
    return now;
}
